import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-base border-y border-silver-light" data-id="element-126" data-mp="1o2vigsgkwt85">
      <div className="max-w-4xl mx-auto" data-id="element-127" data-mp="223oe5gim9ucu">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-white border border-silver-light rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-128" data-mp="222n0r5e4ovry">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-brand" data-id="element-129" data-mp="1j52dg2r0i59g" />
          <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-brand-soft text-brand mb-8" data-id="element-130" data-mp="1ee3t8s2wkn0x">
            <ShieldCheck size={48} aria-hidden="true" data-id="element-131" data-mp="qnhp3bw0rmw7" />
          </div>
          <h2 className="text-3xl md:text-4xl font-display font-extrabold mb-6 text-ink" data-id="element-132" data-mp="lpg2wi3ar7gi">
            🛡️ Complete <span className="text-brand" data-id="element-133" data-mp="ozrn88kaq9yr">7-Day Guarantee</span>
          </h2>
          <div className="space-y-6 text-lg text-graphite max-w-2xl mx-auto" data-id="element-134" data-mp="oxp0bxefwwy9">
            <p data-id="element-135" data-mp="twrxkvo6hyvo">
              Open the complete system. Explore all 6 volumes. Use the material in your most
              challenging class this week.
            </p>
            <p className="font-medium text-ink" data-id="element-136" data-mp="12pv4el4bjdhc">
              If you find the material is not clear, practical, or useful for your coaching needs,
              contact us within 7 days.
            </p>
            <p className="text-brand font-bold text-xl" data-id="element-137" data-mp="b0s41gfjyn9z">
              We&apos;ll refund 100% of your money. No questions. No forms. No hassle.
            </p>
            <p className="text-sm text-graphite-light mt-8" data-id="element-138" data-mp="k0f0dntfd2w6">
              Because if the material doesn&apos;t deliver the value we promise, we don&apos;t want
              to keep your money.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}